/**
 * Fines API - Traffic fine management (ANTAI)
 * @module api/fines
 */

import { apiRequest } from './core.js';

// =============================================================================
// TRAFFIC FINE API
// =============================================================================

/**
 * Traffic Fine API - 45-day driver designation workflow
 * French law requires companies to designate the driver within 45 days
 * Non-compliance fine: 675 EUR (can reach 3,750 EUR)
 */
export const trafficFineAPI = {
  // Get all fines with optional filters
  getAll: (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.status) params.append('status', filters.status);
    if (filters.vehicle_id) params.append('vehicle_id', filters.vehicle_id);
    if (filters.driver_id) params.append('driver_id', filters.driver_id);
    if (filters.urgency) params.append('urgency', filters.urgency);
    if (filters.infraction_type) params.append('infraction_type', filters.infraction_type);
    if (filters.date_from) params.append('date_from', filters.date_from);
    if (filters.date_to) params.append('date_to', filters.date_to);
    const query = params.toString();
    return apiRequest(`/fines${query ? `?${query}` : ''}`);
  },

  getById: (id) => apiRequest(`/fines/${id}`),

  create: (fine) => apiRequest('/fines', {
    method: 'POST',
    body: JSON.stringify(fine),
  }),

  update: (id, fine) => apiRequest(`/fines/${id}`, {
    method: 'PUT',
    body: JSON.stringify(fine),
  }),

  delete: (id) => apiRequest(`/fines/${id}`, {
    method: 'DELETE',
  }),

  // Workflow actions
  process: (id) => apiRequest(`/fines/${id}/process`, {
    method: 'POST',
  }),

  designate: (id, driverId) => apiRequest(`/fines/${id}/designate`, {
    method: 'POST',
    body: JSON.stringify({ driver_id: driverId }),
  }),

  contest: (id, reason) => apiRequest(`/fines/${id}/contest`, {
    method: 'POST',
    body: JSON.stringify({ contest_reason: reason }),
  }),

  pay: (id, paymentDate) => apiRequest(`/fines/${id}/pay`, {
    method: 'POST',
    body: JSON.stringify({ payment_date: paymentDate }),
  }),

  cancel: (id, reason) => apiRequest(`/fines/${id}/cancel`, {
    method: 'POST',
    body: JSON.stringify({ reason }),
  }),

  // Statistics
  getStats: () => apiRequest('/fines/stats'),

  // Get urgent fines (approaching deadline)
  getUrgent: () => apiRequest('/fines/urgent'),
};
